import React, { ReactElement, VFC } from 'react'

import SvgCheck from '@Assets/SVG/Check'
import { ImageV2 } from '@Components/Image'
import {
  PersonalizationSelectImage,
  PersonalizationSelectImageContainer,
  PersonalizationSelectionButton,
  PersonalizationSelectItemRoot,
} from '@Components/Personalization/Styles/Personalization.styled'

interface Props {
  buttonContent: ReactElement
  image: string
  onSelect?: () => void
  withSelect: {
    onSelect: () => void
    selected: boolean
  }
}

// TODO fix images without their original dimensions.
const PersonalizationSelectItemLayout: VFC<Props> = ({
  buttonContent,
  image,
  withSelect,
}) => (
  <PersonalizationSelectItemRoot>
    <PersonalizationSelectImageContainer>
      <PersonalizationSelectImage selected={withSelect?.selected}>
        <ImageV2
          height={200}
          layout="responsive"
          loading="lazy"
          sizes="200px"
          src={image}
          width={200}
        />
        <SvgCheck />
      </PersonalizationSelectImage>
    </PersonalizationSelectImageContainer>
    <PersonalizationSelectionButton
      color="dark"
      onClick={withSelect.onSelect}
      variant="outlined"
    >
      {buttonContent}
    </PersonalizationSelectionButton>

  </PersonalizationSelectItemRoot>
)

export default PersonalizationSelectItemLayout
